import saga from 'Modules/userList/headCount/store/saga'
import reducer from 'Modules/userList/headCount/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelectHeadCount } from 'Modules/userList/headCount/store/selectors'
import { deleteItem, getOneDrive, changName,
  createFolder, moveItem, uploadFile, getDrivesHotLoad,
  getPortfolio, getOneDriveAndBread, getFilesToDownloadFolder,
  removeFilesToDownloadFolder,
  uploadFolder } from 'Modules/userList/headCount/store/actions'

export const useHeadCount = () => {
  useInjectSaga({ key: 'headcount', saga })
  useInjectReducer({ key: 'headcount', reducer })

  const { idParentMove, listFilesToDownload, listBread, portfolioData, isLoading, topLoad, error, listOneDrive, searchDrive, listFolderMove, notes } = useSelector(
    makeSelectHeadCount()
  )

  const dispatch = useDispatch()
  const getPortfolioDataAction = (payload) => dispatch(getPortfolio(payload))
  const getListOneDriveAndBreadAction = (payload) => dispatch(getOneDriveAndBread(payload))
  const getListOneDriveAction = (payload) => dispatch(getOneDrive(payload))
  const deleteItemAction = (payload) => dispatch(deleteItem(payload))
  const changeNameAction = (payload) => dispatch(changName(payload))
  const createFolderAction = (payload) => dispatch(createFolder(payload))
  const moveItemAction = (payload) => dispatch(moveItem(payload))
  const uploadFileAction = (payload) => dispatch(uploadFile(payload))
  const getDrivesHotLoadAction = (payload, callback) => dispatch(getDrivesHotLoad(payload, callback))
  const getFilesToDownloadFolderAction = (payload) => dispatch(getFilesToDownloadFolder(payload))
  const removeFilesToDownloadFolderAction = () => dispatch(removeFilesToDownloadFolder())
  const uploadFolderAction = (payload) => dispatch(uploadFolder(payload))

  return {
    idParentMove,
    listFilesToDownload,
    listBread,
    portfolioData,
    isLoading,
    topLoad,
    error,
    listOneDrive,
    searchDrive,
    listFolderMove,
    notes,
    getPortfolioDataAction,
    getListOneDriveAndBreadAction,
    getListOneDriveAction,
    deleteItemAction,
    changeNameAction,
    createFolderAction,
    moveItemAction,
    uploadFileAction,
    getDrivesHotLoadAction,
    getFilesToDownloadFolderAction,
    removeFilesToDownloadFolderAction,
    uploadFolderAction
  }
}
